module.exports = __webpack_public_path__ + "static/img/blue.55758425.png";